import React, {  Component } from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import { exportPriceSheet } from '../../redux/actions';
import moment from 'moment';

class PriceSheetAdminDateOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            run_date: '',
            isExportPriceSheetServiceCompleted: false,
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false,
            isExportPriceSheetServiceCompleted: false
        });
        this.props.handleDialog && this.props.flag && this.props.handleDialog(this.props.flag, false);
    }

    componentDidMount() {
        const self = this;
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    handleChangeRunDate(date) {
        const self = this;
        self.setState({
            run_date: date
        });
    }

    runReport(event) {
        const self = this;
        let draftRelation = self.props.state.user.relationShipPartyList.responseObject.filter(relationShipList => relationShipList.RELATIONSHIP_TYPE.includes("Draft"));
        const payload = {
            template_name : self.props.runPriceSheet.template_name,
            effective_date : self.props.runPriceSheet.effective_date,
            accountNumber : self.props.userData.accountDetail.responseObject[0].ACCOUNTNUMBER,
            salesAgreement : self.props.userData.selectedPriceSource.AGREEMENT_NUMBER,
            emailId : self.props.userData.userDetails.email,
            priceSheetRunDate: moment(self.state.run_date).format('YYYY-MM-DD'),
            accountName : self.props.userData.accountDetail.responseObject[0].ORGANIZATIONNAME,
            agreementName : self.props.userData.selectedPriceSource.AGREEMENT_NAME,
            isDraft: draftRelation !== null && draftRelation.length > 0 ? true : false 
        }
        const payloadForApi = JSON.parse(JSON.stringify(payload));
        self.props.exportPriceSheet(payloadForApi, response => {
            self.setState({
                isExportPriceSheetServiceCompleted : true
            });
        });
        //userData
        // call the end point 
    }

    render() {
        const self = this;
        const {
            defaultTop,
            width,
            showModalCloseButton
        } = this.props;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                {!self.state.isExportPriceSheetServiceCompleted ? 
                    <div className="overlayDialogWindow" style={{top: defaultTop ? 'initial' : 122, width: width || '30em'}}>
                        {showModalCloseButton && <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>}
                        <h2 className="title">SELECT DATE FOR PRICE SHEET</h2>
                        <div className="">
                            <DatePicker id="run_date" dateFormat="YYYY-MM-DD" placeholderText="yyyy-mm-dd" selected={self.state.run_date} onChange={this.handleChangeRunDate.bind(this)} />
                        </div>
                        <div className="yesButtonContainer">
                            <a className="yesButton blueButton fontSize-10" onClick={this.runReport.bind(this)}>CONTINUE</a>
                        </div>
                        <div className="floatLeft">
                            <a className="noButton blueButton fontSize-10" onClick={this.closeDialog.bind(this)}>CANCEL</a>
                        </div>
                    </div> : 
                    <div className="overlayDialogWindow" style={{top: defaultTop ? 'initial' : 122, width: width || '30em'}}>
                        {showModalCloseButton && <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>}
                            <div className="floatRight">
                                <p>You will receive an email shortly with the Price Sheet link.</p>
                                <a className="blueButton noButton fontSize-10" onClick={this.closeDialog.bind(this)}>Ok</a>
                            </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

const mapDispatchToProps = (dispatch) => ({
    exportPriceSheet : (payload, callback) => dispatch(exportPriceSheet(payload, callback))
});

PriceSheetAdminDateOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(PriceSheetAdminDateOverlayDialog);
export default PriceSheetAdminDateOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/priceSheetAdminDateOverlayDialog.js